import { data } from '../../svg/EntityBuilder/data';
import { makeIcon } from '../makeIcon';

export const EntityBuilder = makeIcon(data, 'entity_builder', 'EntityBuilder');

export default EntityBuilder;
